import { type StaticEncode, Type } from '@sinclair/typebox';
import { MongooseObjectIdOrStringSchema } from './common.dto.js';

export const StripeTransferDTOSchema = Type.Object({
  amount: Type.Number(),
  amount_reversed: Type.Number(),
  channelId: MongooseObjectIdOrStringSchema,
  created: Type.Number(),
  currency: Type.String(),
  id: Type.String(),
  reversals: Type.Object({
    data: Type.Array(
      Type.Object({
        created: Type.Number(),
      }),
    ),
  }),
  reversed: Type.Boolean(),
  tierId: MongooseObjectIdOrStringSchema,
});

export type StripeTransferDTO = StaticEncode<typeof StripeTransferDTOSchema>;
